"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideBreadcrumbsInsideList = exports.showBreadcrumbsInsideList = void 0;
const breadcrumbs = document.querySelector('.breadcrumbs');
const showBreadcrumbsInsideList = () => {
    if (breadcrumbs) {
        breadcrumbs.classList.remove('hidden');
    }
};
exports.showBreadcrumbsInsideList = showBreadcrumbsInsideList;
const hideBreadcrumbsInsideList = () => {
    if (breadcrumbs) {
        breadcrumbs.classList.add('hidden');
    }
};
exports.hideBreadcrumbsInsideList = hideBreadcrumbsInsideList;
